/* eslint-disable babel/camelcase */
/* eslint-disable import/no-unresolved */
import {api} from '@utils/api';
import {
	calculateTransactionFee,
	calculateCharityAmount,
	convertWeight,
} from '@utils/functions';

export const onClickShowAddressModal = dispatch => {
	dispatch({
		type: 'setData',
		data: {showAddressModal: true, showShippingModal: false},
	});
};
export const closeAddressModal = async (
	params,
	id,
	user,
	session,
	dispatch,
) => {
	const obj = {
		showAddressModal: false,
		isInstantBidButtonClicked: false,
	};
	if (params) {
		obj.showShippingModal = true;
		if (id) {
			await api(
				{
					url: `/user/setDefaultAddress`,
					method: 'post',
					data: {
						id: id,
						// eslint-disable-next-line babel/camelcase
						user_id: user._id,
					},
				},
				session,
			);
		}
	}
	dispatch({
		type: 'setData',
		data: {...obj},
	});
};

export const closeCardModal = dispatch => {
	const obj = {
		showPaymentModal: false,
		isInstantBidButtonClicked: false,
	};
	dispatch({
		type: 'setData',
		data: {...obj},
	});
};
export const closeShippingModal = dispatch => {
	dispatch({
		type: 'setData',
		data: {showShippingModal: false, isInstantBidButtonClicked: false},
	});
};

export const closeGoodCauseModal = (data, dispatch) => {
	let key = 'showGoodCauseModalOne';
	if (data === 'two') key = 'showGoodCauseModalTwo';

	dispatch({
		type: 'setData',
		data: {[key]: false, isInstantBidButtonClicked: false},
	});
};

export const closeBuyBeforeModal = dispatch => {
	dispatch({
		type: 'setData',
		data: {
			selectedShippingOption: null,
			showBuyBeforeAuctionModal: false,
			isInstantBidButtonClicked: false,
		},
	});
};

export const onSelectShippingOption = (params, state, dispatch, user) => {
	const obj = {
		showShippingModal: false,
		selectedShippingOption: params.shipping,
		pickupAddress: params.pickupAddress,
		deliveryAddress: params.deliveryAddress,
		ageVerification: params.ageVerification,
	};
	const deliveryCountry =
		obj.selectedShippingOption.type !== 'Instore'
			? obj.deliveryAddress.countryCode
			: obj.pickupAddress.countryCode;

	const deliveryState =
		obj.selectedShippingOption.type !== 'Instore'
			? obj.deliveryAddress.stateCode
			: obj.pickupAddress.stateCode;
	if (user.charity) {
		const selectedCharity = state.charities.find(item => {
			return item._id === user.charity._id;
		});
		obj.selectedGoodCause = selectedCharity;
		obj.deliveryArea = {
			countryCode: deliveryCountry,
			stateCode: deliveryState,
		};
	} else {
		obj.deliveryArea = {countryCode: deliveryCountry, stateCode: deliveryState};
	}
	obj.isInstantBidButtonClicked = true;
	dispatch({
		type: 'setData',
		data: {...obj},
	});
};

export const fetchCustomerCards = async (session, dispatch) => {
	try {
		const cards = await api(
			{
				url: `/user/card-list`,
				method: 'get',
			},
			session,
		);
		if (cards?.status && cards.data.length) {
			dispatch({
				type: 'setData',
				data: {selectedPaymentOption: cards.data[0]},
			});
		}
	} catch (e) {
		// eslint-disable-next-line no-console
		console.log(e.message);
	}
};

export const fetchGoodCauses = async (session, dispatch) => {
	try {
		const charities = await api(
			{
				url: `/user/charities`,
				method: 'POST',
			},
			session,
		);
		if (charities.charity.length > 0) {
			dispatch({type: 'setData', data: {charities: charities.charity}});
		}
	} catch (e) {
		// eslint-disable-next-line no-console
		console.log(e.message);
	}
};

export const nextStep = (instantBidTries, state, dispatch) => {
	if (instantBidTries > 2) {
		dispatch({
			type: 'setData',
			data: {
				showBuyBeforeAuctionModal: true,
				instantBidTries,
			},
		});
		return;
	}
	if (!state.selectedPaymentOption) {
		dispatch({
			type: 'setData',
			data: {showPaymentModal: true},
		});
	} else if (!state.selectedShippingOption) {
		dispatch({
			type: 'setData',
			data: {showShippingModal: true},
		});
	} else if (!state.selectedGoodCause || !state.selectedGoodCause?._id) {
		dispatch({
			type: 'setData',
			data: {showGoodCauseModalOne: true},
		});
	} else {
		dispatch({
			type: 'setData',
			data: {showBuyBeforeAuctionModal: true},
		});
	}
};

export const checkPaymentOption = async (user, session) => {
	try {
		const {data} = await api(
			{
				url: `/user/getcustomerCardlist/${user._id}`,
				method: 'GET',
			},
			session,
		);
		return data;
	} catch (error) {
		return [];
	}
};

export const pickGoodCause = (data, state, dispatch) => {
	if (data === 'pickSelected') {
		dispatch({
			type: 'setData',
			data: {showGoodCauseModalOne: false, showGoodCauseModalTwo: false},
		});
	} else if (data === 'pickRandom') {
		if (state?.charities && state.charities.length) {
			let random = Math.floor(Math.random() * state.charities.length);
			dispatch({
				type: 'setData',
				data: {
					selectedGoodCause: state.charities[random],
					showGoodCauseModalOne: false,
				},
			});
		}
	}
};

export const selectGoodCause = (data, state, dispatch) => {
	if (!data) closeGoodCauseModal('one', dispatch);
	else {
		dispatch({
			type: 'setData',
			data: {
				selectedGoodCause: data,
				showGoodCauseModalTwo: false,
				showGoodCauseModalOne: false,
			},
		});
	}
};

export const createBuyBeforeAuctionOrder = async (
	session,
	state,
	data,
	settings,
	taxAmount,
	taxRate,
	shippingPrice,
) => {
	try {
		let feePercent = settings.default_bt_fee || 10;
		let retailerDonationAmount = 0;
		let endDate = null;
		let startDate = null;
		let retailerDonation = null;
		let retailerCharityId = null;
		const rp = data.product.retailer_products.find(
			p => p.retailer_id === state.activeDropAuction.retailer_id,
		);
		if (rp && rp.transaction_charge_option) {
			feePercent = rp.transaction_charge_percentage;
		} else if (state.retailer) {
			feePercent = state.retailer.transactionChargePercentage;
		}

		if (rp && rp.retailerData && rp.retailerData.charity) {
			retailerDonation = rp.retailerData.retailerDonation.donation_value;
			retailerCharityId = rp.retailerData.charity._id;
			endDate = rp.retailerData.retailerDonation.end_date;
			startDate = rp.retailerData.retailerDonation.start_date;
			retailerDonationAmount =
				((data.bidValue + shippingPrice) *
					rp.retailerData.retailerDonation.donation_value) /
				100;
		}
		let totalTaxAmt = taxAmount;

		const transaction_fee = calculateTransactionFee(feePercent, data.bidValue);

		const extra_fee = parseFloat(transaction_fee * 0.1);
		const total_fee = parseFloat(
			transaction_fee + Math.round(extra_fee * 100) / 100,
		);
		const totalBTFee = Math.round(total_fee * 100) / 100;

		const charityAmount = calculateCharityAmount(
			transaction_fee,
			1,
			data.bidValue + shippingPrice,
			0,
			shippingPrice,
			settings.australia_stripe_fee,
			settings.international_stripe_fee,
			settings.good_cause_percentage,
			state.deliveryAddress ? state.deliveryAddress.country : '',
			state.selectedPaymentOption.country || 'AU',
			retailerDonation,
		);
		const obj = {
			auction_id: data.auctionId,
			order_type: 'instantbid',
			retailer_id: state.activeDropAuction.retailer_id,
			is_stock_set: true,
			payment_source: state.selectedPaymentOption.id,
			stripe_card_country: state.selectedPaymentOption.country || 'AU',
			customer_stripe_id: data.customer_stripe_id,
			shipping_price: shippingPrice,
			shipping_type: state.selectedShippingOption.type,
			transaction_fee: totalBTFee,
			charity_price: charityAmount,
			retailerDonation: {
				totalGc: charityAmount,
				retailerDonation: retailerDonation,
				charityId: state.selectedGoodCause._id,
				startDate: startDate,
				endDate: endDate,
				btTransactionFee: feePercent,
				retailerDonationAmount: retailerDonationAmount,
				retailerCharityId: retailerCharityId,
			},
			actual_shipping_amount: state.selectedShippingOption.actualValue,
			total_price: data.bidValue + shippingPrice,
			charity_id: state.selectedGoodCause._id,
			address_id: state.deliveryAddress
				? state.deliveryAddress._id
				: '6200c810763b7222ce010899',
			deliveryAddress: state.deliveryAddress,
			product_array: [
				{
					product_id: data.product._id,
					variance_id: state.selectedVariance,
					quantity: 1,
					price: data.bidValue,
					taxAmt: totalTaxAmt,
					currency: state.activeDropAuction.Retailer_data.currency || 'AUD',
				},
			],
			parcel: {
				width: data.product.dimensions.width,
				length: data.product.dimensions.length,
				depth: data.product.dimensions.height,
				weight: +convertWeight(
					data.product.dimensions.weight_unit,
					data.product.dimensions.weight,
				),
			},
			totalTaxAmt,
			taxRate,
			ageVerification: state.ageVerification,
		};
		const result = await api(
			{
				url: '/auction/order',
				method: 'post',
				data: obj,
			},
			session,
		);
		if (result.status) {
			return result;
		}
	} catch (error) {
		return {
			status: false,
			message: error.message,
		};
	}
};

export const calcualteFreeShipping = (retailerShipping, selectedShipping) => {
	switch (selectedShipping?.type) {
		case 'ExpressDelivery':
			return retailerShipping['freeExpressShippingAbove'];
		case 'Standard':
			return retailerShipping['freeStandardShippingAbove'];
		case 'International':
			return retailerShipping['freeInternationalShippingAbove'];
		case 'StandardDeliverySendle':
			return retailerShipping['freeSendleShippingAbove'];
		case 'InternationalDelivery':
			return retailerShipping['freeSendleInternationalAbove'];

		default:
			return 0;
	}
};
